import styles from './product-list.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';
import { useGetRequestNewHook } from '../../../../requestUtils';
import { CreateHeaders, HeaderSizeEnum, Icon, PrimaryButton, SecondaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import DeleteRelationProductDialog from '../../../delete-relation-product-dialog/delete-relation-product-dialog';
import EditProductDialog from '../../../edit-product-dialog/edit-product-dialog';
import { IRelationProduct } from '../../../../_models/relation-product';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ProductListProps { }

export function ProductList(props: ProductListProps) {
  const { t } = useTranslation();
  const { data: relationProducts, getData, isLoading }: { data: IRelationProduct[], getData: () => void, isLoading: boolean } = useGetRequestNewHook(`relationProducts`, []);
  const [addRelationProduct, setAddRelationProduct] = useState<boolean>(false);
  const [editProduct, setEditProduct] = useState<IRelationProduct | undefined>(undefined);
  const [deleteRelationProduct, setDeleteRelationProduct] = useState<IRelationProduct | undefined>(undefined);

  const openAddRelationProductDialog = () => setAddRelationProduct(true);
  const closeAddRelationProductDialog = () => {
    setAddRelationProduct(false);
    getData();
  };

  const openEditProductDialog = (e: any) => setEditProduct(e.data);
  const closeEditProductDialog = () => {
    setEditProduct(undefined);
    getData();
  };

  const openDeleteRelationProductDialog = (e: any) => setDeleteRelationProduct(e.data);
  const closeDeleteRelationProductDialog = () => {
    setDeleteRelationProduct(undefined);
    getData();
  };

  const modulesLengthRenderer = (params: ValueFormatterParams) => params.data.moduleIds?.length;
  const systemRelatedLengthRenderer = (params: ValueFormatterParams) => params.data.relatedProductIds?.length;

  const editProductRenderer = (params: ValueFormatterParams) => (
    <PrimaryButton
      variant="outlined"
      size='small'
      onClick={() => openEditProductDialog(params)}>
      {t("standard.changeProduct")}
    </PrimaryButton>
  );

  const deleteProductRenderer = (params: ValueFormatterParams) => (
    <SecondaryButton
      variant="outlined"
      size='small'
      onClick={() => openDeleteRelationProductDialog(params)}>
      {t("standard.deleteProduct")}
    </SecondaryButton>
  );

  const headers = CreateHeaders([
    textHeader("productName", t("standard.productName"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("groupName", t("standard.groupName"), HeaderSizeEnum.LARGE),
    textHeader("parentName", t("productList.parentName"), HeaderSizeEnum.LARGE),
    textHeader("", "Undermoduler", HeaderSizeEnum.MEDIUM, {
      renderer: modulesLengthRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("", t("standard.systemRelatedProducts"), HeaderSizeEnum.MEDIUM, {
      renderer: systemRelatedLengthRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("id", "ID"),
    textHeader("relatedInterests", t("productList.interests"), HeaderSizeEnum.LARGE, {
      renderer: (params: ValueFormatterParams) => params.data.relatedInterests?.map((interest: any) => interest.name).join(", "),
    }),
    textHeader("productCode", t("productList.productCode")),
    textHeader("", "", HeaderSizeEnum.LARGE, {
      renderer: editProductRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("", "", HeaderSizeEnum.LARGE, {
      renderer: deleteProductRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    })
  ]);

  return <>
    <div className="d-flex flex-row align-items-end flex-wrap">
      <div className="mb-3 mb-xxl-0">
        <PrimaryButton
          variant="contained"
          onClick={openAddRelationProductDialog}>
          <Icon className="me-1" fontSize="small">add</Icon>{t("standard.addProduct")}
        </PrimaryButton>
      </div>
    </div>
    <WebkuaTable
      isLoading={isLoading}
      headers={headers}
      data={relationProducts}
    />
    {addRelationProduct && <EditProductDialog
      open={addRelationProduct}
      onClose={closeAddRelationProductDialog}
      productName={""}
      allProducts={relationProducts}
    />}
    {editProduct && <EditProductDialog
      open={!!editProduct}
      onClose={closeEditProductDialog}
      editProduct={editProduct}
      productName={editProduct?.productName}
      allProducts={relationProducts}
    />}
    {deleteRelationProduct && <DeleteRelationProductDialog
      open={!!deleteRelationProduct}
      onClose={closeDeleteRelationProductDialog}
      deleteRelationProduct={deleteRelationProduct}
      productName={deleteRelationProduct.productName}
    />}
  </>;
}

export default ProductList;